import { Injectable, EventEmitter } from '@angular/core';
import { DropdownComponent } from './dropdown.component';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  onClick: EventEmitter<DropdownComponent> = new EventEmitter();

  constructor() {}

  emit(dropdown: DropdownComponent) {
    this.onClick.emit(dropdown);
  }
}
